import { usePhases } from './usePhases'
import { useMemo } from 'react'
import { uniqBy } from 'lodash/fp'
import { Price } from '../cube.domain.types'

export const usePrices = () => {
  const { orderedPhases } = usePhases()

  /**
   * This selector approach ensures we do not include prices which are no
   * longer part of any phase (e.g. deleted prices).
   */
  const allPrices = useMemo(() => {
    return uniqBy<Price>('id')(orderedPhases.flatMap(phase => phase.prices))
  }, [orderedPhases])

  return {
    prices: allPrices
  }
}
